// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1zFQz","title":"FrontImage_title__wsLMW"};